import { Component, OnInit } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Router } from '@angular/router';
import { environment } from '@src/environments/environment';
import { Auth } from 'aws-amplify';
 
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.css']
})
export class ConfirmComponent implements OnInit {
  confirmationCode: string;
  year:string;
  email: string;
  errorMessage: string;
  showconfirmation: boolean;

  constructor(
    private router:Router,
  ) { }

  ngOnInit() {
    this.year = new Date().getFullYear().toString();
    this.showconfirmation=false;
  }
  onConfirmRegistration() {
    
      this.errorMessage = null;
    //   var poolData = {
    //     UserPoolId : environment.cognito_user_pool_id,
    //     ClientId : environment.cognito_client_id
    // };
  
    // var userPool = new CognitoUserPool(poolData);
  
    // var userData = {
    //     Username : SessionHelper.getUserName(),
    //     Pool : userPool,
    // };
  
    // var cognitoUser = new CognitoUser(userData);
        Auth.confirmSignUp(SessionHelper.getUserName(),this.confirmationCode)
        .then(() => {this.showconfirmation=true;})
        .catch((err) => {this.errorMessage = err.message;})
    //   cognitoUser.confirmRegistration(this.confirmationCode, true, (err, result) => {
    //     if (err) {
    //         //callback.cognitoCallback(err.message, null);
    //         this.errorMessage = err.message;
    //     } else {
    //         this.showconfirmation=true;
    //     }
    // });
  }
  ConfirmationAccept(){
      this.router.navigate(['/login']);
  }
  
}
